
// Get all Sections
const allSections = document.querySelectorAll(".bundle_section");
const sectionList = {};

allSections.forEach((section, index) => {
  let sec = section.id;
  sectionList[`section${index + 1}`] = sec;
});
allSections.forEach((sec, index) => {
      if (index <= 6) {
        sec.classList.remove("dn");
      }
    });

// First button click event (6th section "Of course" button)
document
  .querySelector(".t4s-ofcourse-btn")
  .addEventListener("click", function () {
    debugger;

    this.closest("section").classList.add("dn");
    const nextSections = Array.from(allSections).slice(7, 10);
    nextSections.forEach((sec) => {
      sec.classList.remove("dn");
    });
  });

// Second button click event to show remaining sections
document
  .querySelector(".t4s-ofcourse-healthcare-btn")
  .addEventListener("click", function () {
    const remainingSections = Array.from(allSections).slice(10);
    this.closest("section").classList.add("dn");
    remainingSections.forEach((sec) => {
      sec.classList.remove("dn");
    });
  });
// Hiding Section
document.querySelectorAll(".t4s-prs-footer").forEach((bundleDiv) => {
  bundleDiv.addEventListener("click", function (event) {
    const { target, currentTarget } = event;

    if (target.classList.contains("t4s-skip-btn")) {
      debugger;
      const parentSection = currentTarget.closest(`[data-ntajax-options]`);
      const sectionClass = parentSection ? ('shopify-section-' + parentSection.classList[0]) : null;

      if (Object.values(sectionList).includes(sectionClass)) {
        parentSection.style.display = "none";
      }
      currentTarget.style.display = "none";
    } else if (target.classList.contains("t4s-next-btn")) {
      currentTarget.closest("section").nextElementSibling?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  });
});